import React, { useContext, useEffect, useState } from "react";
import {
  Container,
  Stack,
  IconButton,
  Button,
  useMediaQuery,
  Grid,
} from "@mui/material";
import { Box } from "@mui/system";
import presaleImg from "./assets/presale.svg";

//animations

import c1 from "./assets/c1.svg";
import c2 from "./assets/c2.svg";
import c3 from "./assets/c3.svg";
import c4 from "./assets/c4.svg";
import c5 from "./assets/c5.svg";
import c6 from "./assets/c6.svg";
import f1 from "./assets/f1.svg";
import f2 from "./assets/f2.svg";
import f3 from "./assets/f3.svg";
import f4 from "./assets/f4.svg";
import f5 from "./assets/f5.svg";
import d1 from "./assets/d1.svg";
import d2 from "./assets/d2.svg";

import mc1 from "./mAssets/c1.svg";
import mf1 from "./mAssets/f1.svg";
import mf2 from "./mAssets/f2.svg";
import { AppContext, gasEstimationForAll } from "../../utils";
import {
  ToastNotify,
  useNodePresaleContract,
  useUsdcContract,
} from "../../ConnectivityAss/hooks";
import { formatUnits } from "@ethersproject/units";
import Loading from "../../loading";
import { nodePresaleAddress } from "../../ConnectivityAss/Environment";

function PublicPresale() {
  const mobile = useMediaQuery("(max-width:1050px)");
  const { account, signer, connect } = useContext(AppContext);
  const nodePresaleContract = useNodePresaleContract(signer);
  const usdcContract = useUsdcContract(signer);
  const [usdcPrice, setusdcPrice] = useState(0);
  const [soldNodes, setsoldNodes] = useState(0);
  const [totalNodes, settotalNodes] = useState(0);
  const [loading, setloading] = useState(false);

  const [alertState, setAlertState] = useState({
    open: false,
    message: "",
    severity: undefined,
  });
  const init = async () => {
    try {
      const [max, sold, usdc, decimal] = await Promise.all([
        nodePresaleContract.maxSupply(),
        nodePresaleContract.totalSoldNodes(),
        nodePresaleContract.nodeUSDCPrice(),
        usdcContract.decimals(),
      ]);
      setsoldNodes(+sold);
      settotalNodes(+max);
      setusdcPrice(+formatUnits(usdc, decimal));
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    init();
  }, []);

  const buyHandler = async () => {
    try {
      setloading(true);
      const [allowance, balance] = await Promise.all([
        usdcContract.allowance(account, nodePresaleAddress),
        usdcContract.balanceOf(account),
      ]);
      console.log(+allowance < +balance, +allowance, +balance);
      if (+allowance < +balance) {
        let data = [nodePresaleAddress, balance];
        let fn = usdcContract.estimateGas.approve;
        let tx = await usdcContract.approve(...data, {
          gasLimit: gasEstimationForAll(account, fn, data),
        });
        await tx.wait();
      }
      let data = [];
      let fn = nodePresaleContract.estimateGas.buyNode;
      let tx = await nodePresaleContract.buyNode(...data, {
        gasLimit: gasEstimationForAll(account, fn, data),
      });
      await tx.wait();
      await init();
      setloading(false);
      setAlertState({
        open: true,
        message: `Transaction Successfully completed`,
        severity: "success",
      });
    } catch (error) {
      if (error?.data?.message) {
        setAlertState({
          open: true,
          message: error?.data?.message,
          severity: "error",
        });
      } else {
        setAlertState({
          open: true,
          message: error?.message,
          severity: "error",
        });
      }
      setloading(false);
    }
  };
  return (
    <div
      style={{
        background:
          "radial-gradient(68.29% 68.29% at 50% 50%, #73246C 0%, #1A103B 100%)",
        backgroundSize: "cover",
        width: "100%",
        paddingTop: "75px",
        paddingBottom: "75px",
        position: "relative",
        overflowX: "hidden",
        zIndex: "0",
      }}
    >
      <ToastNotify alertState={alertState} setAlertState={setAlertState} />
      <Loading loading={loading} />
      <Container maxWidth="xl">
        <Grid container spacing={3}>
          {/* pre sale card  */}

          <Grid item xs={mobile ? 12 : 6}>
            <Box
              className="border"
              width="100%"
              px={mobile ? "28px" : "62px"}
              py={mobile ? "20px" : "35px"}
              sx={{
                background: " rgba(248, 248, 248, 0.1)",
                backdropFilter: "blur(10px)",
                borderRadius: "20px",
                zIndex: "100",
              }}
            >
              <Stack
                width="100%"
                direction="column"
                alignItems={"center"}
                spacing={3}
              >
                <Box
                  width="100%"
                  sx={{
                    fontSize: mobile ? "26px" : "30px",
                    fontWeight: "400",
                    color: "#FAA631",
                    textAlign: "center",
                    fontFamily: "light",
                  }}
                >
                  {" "}
                  PUBLIC PRE SALE{" "}
                </Box>
                <Box>
                  <img
                    src={presaleImg}
                    style={{ maxWidth: "385px", width: "100%" }}
                    alt=""
                  />
                </Box>

                <Box
                  py={mobile ? "28px" : "38px"}
                  px={mobile ? "20px" : "64px"}
                  width="100%"
                  sx={{
                    background: "rgba(255, 255, 255, 0.3)",
                    boxShadow: "inset 5px 5px 10px rgba(0, 0, 0, 0.25)",
                    borderRadius: "10px",
                    fontFamily: "regular",
                  }}
                >
                  <Stack
                    direction="row"
                    alignItems={"center"}
                    justifyContent="space-between"
                  >
                    <Box>
                      <IconButton
                        sx={{
                          color: "white",
                          "&:hover": {
                            color: "#FAA631",
                          },
                        }}
                      >
                        <i class="fa-solid fa-arrow-left"></i>
                      </IconButton>
                    </Box>

                    <Box>
                      {" "}
                      <Stack
                        direction={"column"}
                        aligItems="center"
                        spacing="8px"
                      >
                        <Box
                          textAlign="center"
                          sx={{
                            fontSize: mobile ? "16px" : "20px",
                            fontWeight: "400",
                            color: "white",
                          }}
                        >
                          Current Batch : 1
                        </Box>
                        <Box
                          textAlign="center"
                          sx={{
                            fontSize: mobile ? "16px" : "20px",
                            fontWeight: "400",
                            color: "white",
                          }}
                        >
                          Supply : {soldNodes}/{totalNodes}
                        </Box>
                        <Box
                          textAlign="center"
                          sx={{
                            fontSize: mobile ? "16px" : "20px",
                            fontWeight: "400",
                            color: "white",
                          }}
                        >
                          Price(Each) : ${usdcPrice}
                        </Box>
                      </Stack>{" "}
                    </Box>
                    <Box>
                      <IconButton
                        sx={{
                          color: "white",
                          "&:hover": {
                            color: "#FAA631",
                          },
                        }}
                      >
                        <i class="fa-solid fa-arrow-right"></i>
                      </IconButton>
                    </Box>
                  </Stack>
                </Box>

                <Box width="100%">
                  {account ? (
                    <Button
                      sx={{
                        fontSize: mobile ? "15px" : "25px",
                        width: "100%",
                        background: "#FAA631",
                        "&:hover": {
                          background: "white",
                          color: "#FAA631",
                        },
                        color: "white",
                        borderRadius: "10px",
                        height: "43px",
                        fontFamily: "light",
                      }}
                      onClick={buyHandler}
                    >
                      BUY
                    </Button>
                  ) : (
                    <Button
                      sx={{
                        fontSize: mobile ? "15px" : "25px",
                        width: "100%",
                        background: "#FAA631",
                        "&:hover": {
                          background: "white",
                          color: "#FAA631",
                        },
                        color: "white",
                        borderRadius: "10px",
                        height: "43px",
                        fontFamily: "light",
                      }}
                      onClick={connect}
                    >
                      CONNECT WALLET
                    </Button>
                  )}
                </Box>
              </Stack>
            </Box>

            {/* m Animattions  */}

            {mobile ? (
              <>
                <Box pb="140px">
                  {/* mf1   */}
                  <img
                    className="updown"
                    src={mf1}
                    style={{
                      position: "absolute",
                      zIndex: "0",
                      marginTop: "-10px",
                      marginLeft: "40px",
                    }}
                    alt=""
                  />

                  {/* mc1   */}
                  <img
                    className="rotate"
                    src={mc1}
                    style={{
                      position: "absolute",
                      zIndex: "0",
                      marginTop: "-10px",
                      marginLeft: "210px",
                    }}
                    alt=""
                  />
                  {/* mf2   */}
                  <img
                    className="diagonal"
                    src={mf2}
                    style={{
                      position: "absolute",
                      zIndex: "0",
                      marginTop: "20px",
                      marginLeft: "210px",
                    }}
                    alt=""
                  />
                </Box>
              </>
            ) : (
              <></>
            )}
          </Grid>

          {mobile ? (
            <></>
          ) : (
            <>
              <Grid item xs={6}>
                <Box>
                  {/* c1   */}
                  <img
                    className="rotateX"
                    src={c1}
                    style={{
                      position: "absolute",
                      zIndex: "0",
                      marginTop: "80px",
                      marginLeft: "-100px",
                    }}
                    alt=""
                  />

                  {/* f1  */}
                  <img
                    className="updown"
                    src={f1}
                    style={{
                      position: "absolute",
                      zIndex: "0",
                      marginTop: "170px",
                      marginLeft: "-70px",
                    }}
                    alt=""
                  />
                  {/* f2  */}

                  <img
                    className="leftRight"
                    src={f2}
                    style={{
                      position: "absolute",
                      zIndex: "0",
                      marginTop: "130px",
                      marginLeft: "160px",
                    }}
                    alt=""
                  />

                  {/* c2  */}
                  <img
                    className="rotateY"
                    src={c2}
                    style={{
                      position: "absolute",
                      zIndex: "0",
                      marginTop: "130px",
                      marginLeft: "350px",
                    }}
                    alt=""
                  />
                  {/* f3  */}
                  <img
                    src={f3}
                    className="diagonal"
                    style={{
                      position: "absolute",
                      zIndex: "2",
                      marginTop: "410px",
                      marginLeft: "100px",
                    }}
                    alt=""
                  />
                  {/* c3  */}
                  <img
                    className="rotateX"
                    src={c3}
                    style={{
                      position: "absolute",
                      zIndex: "0",
                      marginTop: "340px",
                      marginLeft: "200px",
                    }}
                    alt=""
                  />
                  {/* c4  */}
                  <img
                    className="rotateX"
                    src={c4}
                    style={{
                      position: "absolute",
                      zIndex: "0",
                      marginTop: "320px",
                      marginLeft: "410px",
                    }}
                    alt=""
                  />
                  {/* c5  */}
                  <img
                    src={c5}
                    className="rotateY "
                    style={{
                      position: "absolute",
                      zIndex: "0",
                      marginTop: "500px",
                      marginLeft: "300px",
                    }}
                    alt=""
                  />
                  {/* c6  */}
                  <img
                    className="rotateY "
                    src={c6}
                    style={{
                      position: "absolute",
                      zIndex: "1",
                      marginTop: "360px",
                      marginLeft: "0px",
                    }}
                    alt=""
                  />
                  {/* f5 */}
                  <img
                    src={f5}
                    className="updown"
                    style={{
                      position: "absolute",
                      zIndex: "0",
                      marginTop: "580px",
                      marginLeft: "50px",
                    }}
                    alt=""
                  />
                  {/* d1 */}
                  <img
                    className="rotate"
                    src={d1}
                    style={{
                      position: "absolute",
                      zIndex: "0",
                      marginTop: "690px",
                      marginLeft: "330px",
                    }}
                    alt=""
                  />
                  {/* d2 */}
                  <img
                    className="rotate"
                    src={d2}
                    style={{
                      position: "absolute",
                      zIndex: "0",
                      marginTop: "730px",
                      marginLeft: "420px",
                    }}
                    alt=""
                  />
                </Box>
              </Grid>
            </>
          )}
        </Grid>
      </Container>
    </div>
  );
}

export default PublicPresale;
